// The three ways to start a search on the Play page, and what each one sends.
// Settings are my_user.mode_settings (services\matchmaking\modes\ModeSettings):
// { friendlies|ranked|doubles: { distance_severity_id, match_count, queue_type, ranks } }.
// A null match_count or queue_type means the player never chose one.

import { __ } from 'i18n/index';

export const FRIENDLIES = 'friendlies';
export const RANKED = 'ranked';
export const DOUBLES = 'doubles';
export const MODES = [FRIENDLIES, RANKED, DOUBLES];

// The start buttons on Find a match, in order.
export const MODE_BUTTONS = [
	{ mode: FRIENDLIES, label: () => __('Friendlies'), iconClass: 'fa-play' },
	{ mode: RANKED, label: () => __('Ranked'), iconClass: 'fa-trophy' },
	{ mode: DOUBLES, label: () => __('2v2 Doubles'), iconClass: 'fa-users' },
];

// Ladder_Match_Queue_Setting queue types (Match.CUSTOM_QUEUE_ONLY and friends).
export const LISTED_ONLY = 0;
export const AUTO_MATCH_ONLY = 1;
export const AUTO_MATCH_AND_LISTED = 2;

// services\matchmaking\modes\DistancePreference, saved as distance_severity_id:
// how far the auto queue looks. Prefer nearby widens to anyone as the search
// waits; nearby only never pairs beyond Close (1,600 km). Distance never
// limits challenges.
export const NEARBY_ONLY = 2;
export const PREFER_NEARBY = 5;
export const ENDLESS = 0;
const RANKED_GAME_COUNT = 3;

// Opponent rank directions (Match_Tier_Setting).
export const RANK_AND_ABOVE = 1;
export const RANK_AND_BELOW = -1;
export const RANK_AND_BELOW_OR_UNRANKED = -2;

const settingsForMode = (mode, modeSettings) => (modeSettings && modeSettings[mode]) || {};

// What the mode searches with: its saved values, the defaults for any it
// never saved, and ranked's fixed Best of 3 found automatically.
export function effectiveModeOptions(mode, modeSettings) {
	const settings = settingsForMode(mode, modeSettings);
	const nearbyOnly = (settings.distance_severity_id ?? PREFER_NEARBY) < PREFER_NEARBY;
	if(mode === RANKED) {
		return { nearbyOnly, gameCount: RANKED_GAME_COUNT, queueType: AUTO_MATCH_ONLY };
	}
	return {
		nearbyOnly,
		gameCount: settings.match_count ?? ENDLESS,
		queueType: settings.queue_type ?? AUTO_MATCH_AND_LISTED,
	};
}

// One play option for gameTypeClick (react/redux/actions/matchSelection).
export function searchOptionsForMode(mode, modeSettings, ladderId) {
	const { gameCount, queueType } = effectiveModeOptions(mode, modeSettings);
	return {
		ladderId,
		teamSize: mode === DOUBLES ? 2 : 1,
		isRanked: mode === RANKED,
		gameCount,
		queueVisibilityType: queueType,
	};
}

// { name_id, direction, division } for the ladder, or null for any rank.
// PHP sends an empty list, not an object, when the mode has no ranks.
export function modeRankForLadder(mode, modeSettings, ladderId) {
	const ranks = settingsForMode(mode, modeSettings).ranks;
	if(!ranks || Array.isArray(ranks)) {
		return null;
	}
	return ranks[ladderId] || null;
}
